<template>
    <span>
        <pazar12-types></pazar12-types>
        <pazar12-modules></pazar12-modules>
        <page-footer></page-footer>
    </span>
</template>

<script>
import Pazar12Types from '@/components/Pazar12Types';
import Pazar12Modules from '@/components/Pazar12Modules';
import PageFooter from '@/components/PageFooter';
export default {
    name: 'pazarV12',
    components: {
        Pazar12Types,
        Pazar12Modules,
        PageFooter
    },
    methods: {
        // priceList() {
        //     let productCode = 'pazarV12'
        //     this.$store.dispatch('getPriceList', productCode);
        // }
    },
    mounted: function() {
        // this.priceList();
    }
};
</script>


